// extracted by mini-css-extract-plugin
module.exports = {"toggleBox":"checkboxFancybox_toggleBox__wye0C","checked":"checkboxFancybox_checked__MxaSY"};